import React, {ReactElement} from 'react';
import {useDispatch} from 'react-redux';

import Row from '../../common/Row';
import {Actions} from '../gameSlice';
import {useCurrentQuestionComputed} from '../hooks';
import ArrowButton from './buttons/ArrowButton';
import MessageBox from './MessageBox';
import Question from './Question';

const Years = (): ReactElement | null => {
  const dispatch = useDispatch();
  const currentQuestion = useCurrentQuestionComputed();

  if (!currentQuestion)
    return (
      <MessageBox
        bottom={
          <Row className={'justify-center'}>
            <ArrowButton onClick={() => dispatch(Actions.loadNextQuestion())} direction={'right'}>
              Continue
            </ArrowButton>
          </Row>
        }
      >
        No questions found
      </MessageBox>
    );

  return <Question question={currentQuestion} />;
};

export default Years;

//gameSlice.caseReducers.goToNextQuestion(state);
